import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from 'chart.js';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Router} from '@angular/router';

@Component({
    selector: 'app-bar-chart-stable-unstable-age-uc',
    templateUrl: './bar-chart-stable-unstable-age-uc.component.html',
    styleUrls: ['./bar-chart-stable-unstable-age-uc.component.css']
})

export class BarChartStableUnstableAgeUCComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription: Subscription;
  subscription1: Subscription;
  // ******************************************************************************************************************
  // bar chart dei pazienti globali malati in miglioramento, in peggioramento, stabili, per genere
  // ******************************************************************************************************************
  // bar chart arrays
  remissione = [];
  recidiva = [];
  // 020, 2040, GSCOS, IMM, 60
  // other arrays
  stabiliRecidiva020 = 0;
  stabiliRemissione020 = 0;
  instabiliMiglRecidiva020 = 0;
  instabiliPegRecidiva020 = 0;
  instabiliMiglRemissione020 = 0;
  instabiliPegRemissione020 = 0;
  
  stabiliRecidiva2040 = 0;
  stabiliRemissione2040 = 0;
  instabiliMiglRecidiva2040 = 0;
  instabiliPegRecidiva2040 = 0;
  instabiliMiglRemissione2040 = 0;
  instabiliPegRemissione2040 = 0;
  
  stabiliRecidiva4060 = 0;
  stabiliRemissione4060 = 0;
  instabiliMiglRecidiva4060 = 0;
  instabiliPegRecidiva4060 = 0;
  instabiliMiglRemissione4060 = 0;
  instabiliPegRemissione4060 = 0;

  stabiliRecidiva60 = 0;
  stabiliRemissione60 = 0;
  instabiliMiglRecidiva60 = 0;
  instabiliPegRecidiva60 = 0;
  instabiliMiglRemissione60 = 0;
  instabiliPegRemissione60 = 0;

  // elements for chart
  canvas: any;
  ctx: any;
  myChartStableUnstableUCAge: Chart;
  // ******************************************************************************************************************
  // bar chart
  // ******************************************************************************************************************
  public barChartLabelsGlobal = ['0-20 ANNI-STABILI','0-20 ANNI-IN MIGLIORAMENTO','0-20 ANNI-IN PEGGIORAMENTO',
  '20-40 ANNI-STABILI','20-40 ANNI-IN MIGLIORAMENTO','20-40 ANNI-IN PEGGIORAMENTO',
  '40-60 ANNI-STABILI','40-60 ANNI-IN MIGLIORAMENTO','40-60 ANNI-IN PEGGIORAMENTO',
  '60+ ANNI-STABILI','60+ ANNI-IN MIGLIORAMENTO','60+ ANNI-IN PEGGIORAMENTO'];
  public barChartTypeGlobal = 'horizontalBar';
  public barChartLegendGlobal = true;
  public barChartDataGlobal = [
    {
      data: this.recidiva,
      barThickness: 10,
      backgroundColor: ['#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', 
      '#ff5232','#ff5232', '#ff5232', '#ff5232'],
      hoverBackgroundColor: ['#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507','#d11507', '#d11507',
      '#d11507','#d11507', '#d11507', '#d11507'],
      label: 'RECIDIVA',
      datalabels: {
        color: 'white', // Color for percentage value
      }
    },
    {
      data: this.remissione,
      barThickness: 10,  // number (pixels) or 'flex'
      backgroundColor: ['#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e',
      '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e'],
      hoverBackgroundColor: ['#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c',
      '#03c03c','#03c03c', '#03c03c', '#03c03c'],
      label: 'REMISSIONE',
      datalabels: {
        color: 'white' // Color for percentage value}
      }
    }
    ];
  // table
  dataSource = new MatTableDataSource();
  headElements = ['name', 'surname', 'card', 'questionnaire', 'email', 'chat'];
  totalSize = 0;
  // TABELLE DISPONIBILI
  isHovered = false;
  // paginator della tabella
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrieveAgeStableAndUnstable();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
  }

  retrieveAgeStableAndUnstable(){
    this.subscription = this.doctorService.getUCStableAndUnstableAge().subscribe( data => {
      let keys = Object.keys(data);
      console.log("Data therapy: " + data);
      let values = Object.values(data);
      for (let i in keys){
        var key = keys[i];
        //console.log("Key..." + key);
        if (key === 'StabiliRemissione020'){
          this.stabiliRemissione020 = values[i];
        }
        else if (key === 'StabiliRecidiva020'){
          this.stabiliRecidiva020 = values[i];
        }
        else if (key === 'InstabiliMiglRecidiva020'){
          this.instabiliMiglRecidiva020 = values[i];
        }
        else if (key === 'InstabiliPegRecidiva020'){
          this.instabiliPegRecidiva020 = values[i];
        }
        else if (key === 'InstabiliMiglRemissione020'){
          this.instabiliMiglRemissione020 = values[i];
        }
        else if (key === 'InstabiliPegRemissione020'){
          this.instabiliPegRemissione020 = values[i];
        }
        else if (key === 'StabiliRemissione2040'){
          this.stabiliRemissione2040 = values[i];
        }
        else if (key === 'StabiliRecidiva2040'){
          this.stabiliRecidiva2040 = values[i];
        }
        else if (key === 'InstabiliMiglRecidiva2040'){
          this.instabiliMiglRecidiva2040 = values[i];
        }
        else if (key === 'InstabiliPegRecidiva2040'){
          this.instabiliPegRecidiva2040 = values[i];
        }
        else if (key === 'InstabiliMiglRemissione2040'){
          this.instabiliMiglRemissione2040 = values[i];
        }
        else if (key === 'InstabiliPegRemissione2040'){
          this.instabiliPegRemissione2040 = values[i];
        }
        else if (key === 'StabiliRemissione4060'){
          this.stabiliRemissione4060 = values[i];
        }
        else if (key === 'StabiliRecidiva4060'){
          this.stabiliRecidiva4060 = values[i];
        }
        else if (key === 'InstabiliMiglRecidiva4060'){
          this.instabiliMiglRecidiva4060 = values[i];
        }
        else if (key === 'InstabiliPegRecidiva4060'){
          this.instabiliPegRecidiva4060 = values[i];
        }
        else if (key === 'InstabiliMiglRemissione4060'){
          this.instabiliMiglRemissione4060 = values[i];
        }
        else if (key === 'InstabiliPegRemissione4060'){
          this.instabiliPegRemissione4060 = values[i];
        }
        else if (key === 'StabiliRemissione60'){
          this.stabiliRemissione60 = values[i];
        }
        else if (key === 'StabiliRecidiva60'){
          this.stabiliRecidiva60 = values[i];
        }
        else if (key === 'InstabiliMiglRecidiva60'){
          this.instabiliMiglRecidiva60 = values[i];
        }
        else if (key === 'InstabiliPegRecidiva60'){
          this.instabiliPegRecidiva60 = values[i];
        }
        else if (key === 'InstabiliMiglRemissione60'){
          this.instabiliMiglRemissione60 = values[i];
        }
        else if (key === 'InstabiliPegRemissione60'){
          this.instabiliPegRemissione60 = values[i];
        }
      }
      
      // riempio il vettore della categoria 'recidiva' in ordine stabili, miglioramento e peggioramento
      this.recidiva.push(this.stabiliRecidiva020);
      this.recidiva.push(this.instabiliMiglRecidiva020);
      this.recidiva.push(this.instabiliPegRecidiva020);
      this.recidiva.push(this.stabiliRecidiva2040);
      this.recidiva.push(this.instabiliMiglRecidiva2040);
      this.recidiva.push(this.instabiliPegRecidiva2040);
      this.recidiva.push(this.stabiliRecidiva4060);
      this.recidiva.push(this.instabiliMiglRecidiva4060);
      this.recidiva.push(this.instabiliPegRecidiva4060);
      this.recidiva.push(this.stabiliRecidiva60);
      this.recidiva.push(this.instabiliMiglRecidiva60);
      this.recidiva.push(this.instabiliPegRecidiva60);
      console.log("Recidiva: " + this.recidiva);
      // riempio il vettore della categoria 'remissione' in ordine, stabili, miglioramento e peggioramento
      this.remissione.push(this.stabiliRemissione020);
      this.remissione.push(this.instabiliMiglRemissione020);
      this.remissione.push(this.instabiliPegRemissione020);
      this.remissione.push(this.stabiliRemissione2040);
      this.remissione.push(this.instabiliMiglRemissione2040);
      this.remissione.push(this.instabiliPegRemissione2040);
      this.remissione.push(this.stabiliRemissione4060);
      this.remissione.push(this.instabiliMiglRemissione4060);
      this.remissione.push(this.instabiliPegRemissione4060);
      this.remissione.push(this.stabiliRemissione60);
      this.remissione.push(this.instabiliMiglRemissione60);
      this.remissione.push(this.instabiliPegRemissione60);
      console.log("Remissione: " + this.remissione);
      this.canvasSetting();
    }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  canvasSetting() {
    this.canvas = document.getElementById('myChartStableUnstableUCAge') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.myChartStableUnstableUCAge = new Chart(this.ctx, {
      type: this.barChartTypeGlobal,
      data: {
        labels: this.barChartLabelsGlobal,
        datasets: this.barChartDataGlobal,
      },
      options: {
        maintainAspectRatio: true,
        responsive: true,
        onHover: (event) => {
          if (this.myChartStableUnstableUCAge.getElementAtEvent(event).length > 0) {
            if (this.myChartStableUnstableUCAge.getElementAtEvent(event)[0]['_model'].datasetLabel === 'RECIDIVA' ||
              this.myChartStableUnstableUCAge.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE') {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          }
        },
        scales: {
          xAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
          yAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
        },
        legend: {
          onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
            if (legendItem.text.length > 0 && (legendItem.text === 'RECIDIVA' || legendItem.text === 'REMISSIONE')) {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          },
          display: true,
          position: 'top',
          align: 'center',
          labels: {
            usePointStyle: true,
            fontColor: '#006192',
            fontSize: 18,
            fontFamily: 'Helvetica',
          }
        },
        tooltips: {
          // content: '{pathology}: {number}',
          backgroundColor: '#1c1c1c',
          bodyFontSize: 18,
          titleFontSize: 18,
          cornerRadius: 5,
          caretPadding: 10
        },
        title: {
          display: true,
          text: 'Numero di pazienti',
          fontColor: '#006192',
          fontSize: 20,
          fontFamily: 'Helvetica',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        }
      }
    });
    }

    // pagination della tabella di stabili recidiva patients
  // paginazione effettuata manualmente
  getPagination(data) {
    console.log(data);
    this.dataSource = new MatTableDataSource<Patient>();
    // this.dataSource.data = data;
    this.tasks = data;
    this.currentPage = 0; // così che appena si seleziona il grafico appaia la giusta pagina con le prime persone
    this.totalSize = this.tasks.length;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  // set hovered variable
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/general-status');
  }
  openQuestionnaire(patient) {
    this.router.navigateByUrl('/patient-questionnaires-show/' + patient.ssn + '/patient-sccai' + '/general-status');
  }
  openChat(patient) {
    this.router.navigateByUrl('/doctor-chat/' + patient.ssn + '/general-status');
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log('fired'));
  }

}